import FlashLib from "flashlib";
import {TweenMax, Linear, TimelineMax} from "gsap/TweenMax";
import SymbolsPool from '../symbols/SymbolsPool';
import Utils from '../../Utils';
import GlobalDispatcher from "../../events/GlobalDispatcher";
import EntryPoint from "../../EntryPoint";

export default class BaseSlotReel extends FlashLib.MovieClip {
    constructor(data, displayItemData) {
        super(data, displayItemData);

        this.stopType = 'normal';
        this.id = null;
        this.symbols = [];
        this.data = null;
        this.rollingTween = null;
        this.config = EntryPoint.configData;
        this.totalSymbolsCount = 5;
        this.activeReel = true;
        this.rollingReel = false;

        this.removeChildren();
    }

    setData(id, data, config) {
        this.id = id;
        this.data = data;

        this.symbolTopOffset = this.config.reels.symbolTopOffset || 0;
        this.possibleSymbols = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
        if (this.config.reels.possibleSymbols && this.config.reels.possibleSymbols[id - 1] && this.config.reels.possibleSymbols[id - 1].length > 0) {
            this.possibleSymbols = this.config.reels.possibleSymbols[id - 1];
        }

        this.init();
        this.updateSymbolsPositions();
        this.createTweens();
    }

    init() {
        this.totalSymbolsCount = this.config.reels.topInvisibleSymbolsCount + this.config.reels.symbolsInReel + this.config.reels.bottomInvisibleSymbolsCount;
        for (let i = 0; i < this.totalSymbolsCount; i++) {
            let symbol = SymbolsPool.poolOut(this.possibleSymbols[Utils.getRandomInt(0, this.possibleSymbols.length - 1)], this.id);
            symbol.setActive(this.activeReel);
            this.addChild(symbol);
            this.symbols.push(symbol);
        }

        this.data.forEach((item, index) => {
            this.symbols[index + this.config.reels.topInvisibleSymbolsCount].changeSymbol(item);
        });
    }

    createTweens() {
        if (this.rollingTween) this.rollingTween.kill();
        if (this.startTween) this.startTween.kill();
        if (this.stopTween) this.stopTween.kill();

        this.rollingTween = TweenMax.to(this.symbols, 0.07, {
            y: '+=' + (this.config.symbols.height + this.symbolTopOffset), repeat: -1, /*paused:true,*/
            ease: Linear.easeNone,
            onRepeat: this.onRollingTweenRepeat,
            onStart: this.onRollingTweenStart,
            callbackScope: this
        });

        this.startTween = new TimelineMax({paused: true});
        this.startTween.to(this.symbols, 0.2, {y: '-=' + (this.config.symbols.height + this.symbolTopOffset), yoyo: true, repeat: 1});
        this.startTween.add(this.rollingTween);

        this.stopTween = TweenMax.to(this.symbols, 1, {y: 0, paused: true});
    }

    onRollingTweenStart() {
        this.symbols.forEach((symbol) => {
            symbol.setBlur(true);
        });
    }

    onRollingTweenRepeat() {
        this.rollingTween.invalidate();
        this.symbols.unshift(this.symbols.pop());
        this.symbols[0].changeSymbol(this.possibleSymbols[Utils.getRandomInt(0, this.possibleSymbols.length - 1)]);
        this.updateSymbolsPositions();
    }

    onStopTweenStart() {
        this.symbols.forEach((symbol) => {
            symbol.setBlur(false);
        });
    }

    onStopTweenComplete() {
        while (this.symbols.length > this.totalSymbolsCount) {
            SymbolsPool.poolIn(this.symbols.pop())
        }
        GlobalDispatcher.dispatch('reel:stopped', this.id);
    }

    updateSymbolsPositions() {
        this.symbols.forEach((symbol, index) => {
            //symbol.y = symbol.height * (index - 1);
            symbol.y = (this.config.symbols.height + this.symbolTopOffset) * (index - 1);
        });
    }

    startReel() {
        this.createTweens();
        this.rollingReel = true;
        this.startTween.invalidate();
        this.startTween.play(0);
    }

    stopReel(data, stopType = 'normal') {
        this.rollingReel = false;
        this.stopType = stopType;
        this.data = data;

        this.rollingTween.pause();

        let reversed = this.data.concat().reverse();
        reversed.forEach((id) => {
            this.addNewSymbol(id);
        });
        reversed = null;
        for (let i = 0; i < this.config.reels.topInvisibleSymbolsCount; i++) {
            this.addNewSymbol(this.possibleSymbols[Utils.getRandomInt(0, this.possibleSymbols.length - 1)]);
        }

        this.correctStopTween();
        this.stopTween.play(0);
    }

    startAnimationWinningSymbols(id) {
        this.symbols[id + this.config.reels.topInvisibleSymbolsCount].startAnimation();
    }

    stopAnimationWinningSymbols() {
        this.symbols.forEach((symbol) => {
            symbol.stopAnimation();
        });
    }

    addNewSymbol(id) {
        let newSymbol = SymbolsPool.poolOut(id);
        newSymbol.setBlur(this.rollingReel);
        newSymbol.setActive(this.activeReel);
        newSymbol.y = this.symbols[0].y - /*this.symbols[0].height*/ (this.config.symbols.height +  + this.symbolTopOffset);
        this.addChild(newSymbol);
        this.symbols.unshift(newSymbol);
    }

    correctStopTween() {
        this.stopTween = TweenMax.to(this.symbols, EntryPoint.GameSettings.quickSpin ? 0.3 : 1, {
            y: '+=' + this.symbols[1].y * -1, paused: true, 
            onComplete: this.onStopTweenComplete, 
            onStart: this.onStopTweenStart(),
            callbackScope: this
        });
    }
}